import { isProxyEdge, type LooseEdge } from './graph-lowering'

/**
 * The graph the AI reads and edits (compound audit step 6, 2026-10-06): the
 * canvas's own nodes and ids over its canonical wires. A collapsed subnet's
 * proxy wires are its drawing of those, and read as a second source on the
 * socket they shadow.
 *
 * Not the engine view: apply_graph_ops addresses canvas ids through
 * graphToRecipe's idMap, and the cluster a Trade Manager lowers to has ids
 * only the engine view holds, so a model reading the cluster would issue edits
 * that fail. The read, the ops' idMap and the diff card all go through this,
 * since graphToRecipe numbers its steps in wire order: one view, one id space.
 * Validation is the other half: it reads the engine view (computeGraphReadiness).
 */
export function aiGraphView<N, E extends LooseEdge>(
  nodes: N[],
  edges: E[],
): { nodes: N[]; edges: E[] } {
  return { nodes, edges: edges.filter((e) => !isProxyEdge(e)) }
}
